import type {SubscriptionsState, StateSlice} from '@src/stores/types.ts';
import type {
  FeatureCollectionId,
  FeatureRef,
} from '@src/types/featureCollections.ts';

export const initialState = {
  selectedFeatureCollectionId: null,
  selectedFeatureRef: null,
  subscribeToEntireCollection: false,
};

export const setSubscriptionsSlice: StateSlice<SubscriptionsState> = set => ({
  ...initialState,
  selectFeatureCollectionId: (featureCollectionId: FeatureCollectionId) =>
    set(
      state => {
        state.subscriptions.selectedFeatureCollectionId = featureCollectionId;
      },
      undefined,
      'subscriptions/selectFeatureCollectionId',
    ),
  selectFeatureRef: (featureRef: FeatureRef) =>
    set(
      state => {
        state.subscriptions.selectedFeatureRef = featureRef;
      },
      undefined,
      'subscriptions/selectFeatureRef',
    ),
  setSubscribeToEntireCollection: (newValue: boolean) =>
    set(
      state => {
        state.subscriptions.subscribeToEntireCollection = newValue;
      },
      undefined,
      'subscriptions/setSubscribeToEntireCollection',
    ),
});
